import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  dropdownLookup,
  submitForm as submitFormAPICall,
  submitCaptcha as submitCaptchaAPICall,
  requestCaptcha,
} from "./API";

export const getDropdownData = createAsyncThunk(
  "tr/getDropdownData",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    return dropdownLookup()
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const submitFormAsync = createAsyncThunk(
  "tr/submitForm",
  async (_, { getState, rejectWithValue, fulfillWithValue }) => {
    return submitFormAPICall(getState().tr.formState.values)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const refreshCaptchaAsync = createAsyncThunk(
  "tr/refreshCaptcha",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    return requestCaptcha()
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);
export const submitCaptchaAsync = createAsyncThunk(
  "tr/submitCaptcha",
  async (captcha, { rejectWithValue, fulfillWithValue }) => {
    return submitCaptchaAPICall(captcha)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);
export const appSlice = createSlice({
  name: "tr",
  initialState: {
    page: 0,
    loading: false,
    errors: null,
    dropdownoptions: [],
    requiredFiles: [],
    dropdownsloading: false,
    captchaAudio: null,
    captchaImage: null,
    confirmMessage: null,
    confirmTitle: null,
    /*     caseExistingMessage: null, */
  },
  reducers: {
    updateFormState: (state, action) => {
      state.formState = action.payload;
    },
    cancel: (state) => {
      //Preserve fromData: state.page = 0;
      state.loading = false;
      state.errors = null;
      state.page = 0;
      state.formState = null;
    },
    clearErrors: (state) => {
      state.errors = null;
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setConfirmMessage: (state, action) => {
      //debugger;
      state.confirmMessage = action.payload.confirmmessage;
      state.confirmTitle = action.payload.confirmtitle;
    },
    /*     setCaseClearCaseExistingMessageAndContinue: (state, action) => {
      state.caseExistingMessage = null;
      state.page = 5;
    }, */
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDropdownData.pending, (state) => {
        state.dropdownsloading = true;
      })
      .addCase(getDropdownData.fulfilled, (state, action) => {
        state.dropdownsloading = false;
        state.dropdownoptions = action.payload;
      })
      .addCase(getDropdownData.rejected, (state, action) => {
        state.dropdownsloading = false;
        state.errors = action.payload;
      })
      .addCase(submitFormAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitFormAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.captchaImage = action.payload.captchaImage;
        state.captchaAudio = action.payload.captchaAudio;
        state.page = 4;
      })
      .addCase(submitFormAsync.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addCase(submitCaptchaAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.requiredFiles = action.payload.requiredFiles;
        state.page = 5;
      })
      .addCase(submitCaptchaAsync.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addCase(submitCaptchaAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshCaptchaAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.captchaImage = action.payload.captchaImage;
        state.captchaAudio = action.payload.captchaAudio;
      })
      .addCase(refreshCaptchaAsync.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addCase(refreshCaptchaAsync.pending, (state) => {
        state.loading = true;
      });
  },
});

export const {
  cancel,
  updateFormState,
  clearErrors,
  setErrors,
  setPage,
  setConfirmMessage,
  /*   setCaseClearCaseExistingMessageAndContinue, */
} = appSlice.actions;
export const currentPage = (state) => state?.tr?.page;
export const isLoading = (state) => state?.tr?.loading;
export const errors = (state) => state?.tr?.errors;
export const formState = (state) => state?.tr?.formState;
export const trusttype = (state) => state?.tr?.formState?.values.trustType;
export const dropdownopts = (state) => state?.tr?.dropdownoptions;
export const dropdownsloading = (state) => state?.tr?.dropdownsloading;
export const requiredFiles = (state) => state?.tr?.requiredFiles;
export const captchaAudio = (state) => state?.tr?.captchaAudio;
export const captchaImage = (state) => state?.tr?.captchaImage;
export const confirmMessage = (state) => state?.tr?.confirmMessage;
export const confirmTitle = (state) => state?.tr?.confirmTitle;
/* export const caseExistingMessage = (state) => state?.tr?.caseExistingMessage; */

export default appSlice.reducer;
